module.exports = __webpack_public_path__ + "img/pic2.fe24d104.png";